import { type SpeakerProfile, emotionMeta } from './types';

/**
 * כרטיס ניתוח פרופיל לדובר: תכונות אישיות (chips) + הרגשות הדומיננטיים
 * (אמוג'י + עברית + עוצמה). מקביל לכרטיסיית "John Doe" מהעיצוב.
 */
export function SpeakerProfileCard({ label, color, profile }: {
  label: string; color: string; profile?: SpeakerProfile;
}) {
  if (!profile) return null;
  const traits = profile.traits ?? [];
  const strongest = profile.strongest_emotions ?? [];

  return (
    <div style={{ border: '1px solid var(--line)', borderRadius: 'var(--r-2)', padding: 12, background: 'var(--surface)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <span style={{ width: 10, height: 10, borderRadius: '50%', background: color }} />
        <strong>{label}</strong>
        {profile.arc && <span style={{ fontSize: 'var(--t-xs)', color: 'var(--muted)' }}>· {profile.arc}</span>}
      </div>

      {traits.length > 0 && (
        <div style={{ marginBottom: 8 }}>
          <div style={{ fontSize: 'var(--t-xs)', color: 'var(--muted)', marginBottom: 4 }}>תכונות אישיות</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {traits.map((t, i) => (
              <span key={i} style={{ fontSize: 'var(--t-xs)', padding: '2px 8px', borderRadius: 999, background: 'var(--surface-2)', border: '1px solid var(--line)' }}>{t}</span>
            ))}
          </div>
        </div>
      )}

      {strongest.length > 0 && (
        <div>
          <div style={{ fontSize: 'var(--t-xs)', color: 'var(--muted)', marginBottom: 4 }}>רגשות דומיננטיים</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {strongest.map((s, i) => {
              const m = emotionMeta(s.emotion);
              return (
                <span key={i} title={`${Math.round((s.score ?? 0) * 100)}%`}
                  style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 'var(--t-xs)', padding: '2px 8px', borderRadius: 999, background: m.color + '22', color: m.color, border: `1px solid ${m.color}55` }}>
                  {m.emoji} {m.he}
                </span>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
